import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule } from '@angular/material/core';
import { NgxPaginationModule } from 'ngx-pagination';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { EllipsisComponent } from '../ellipsis/ellipsis.component';
import { FiltersModule } from '../filters/filters.module';
import { MonthPickerComponent } from './components/month-picker/month-picker.component';
import { CardTableActionComponent, CardTableActionsComponent, CardTableComponent, CardTableRowComponent } from './components';
import { CardTableHeaderComponent } from './components/card-table-header/card-table-header.component';
import { GenericTableHeaderComponent } from './components/generic-table-header/generic-table-header.component';
import { ObjectValuesPipe, PropertyCleanPipe } from './pipes';
import { YearPickerComponent } from './components/year-picker/year-picker.component';
import { DateTimePickerComponent } from './components/date-time-picker/date-time-picker.component';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { MatColComponent } from '../mat-col/mat-col.component';
import { MatRowComponent } from '../mat-row/mat-row.component';

@NgModule({
  declarations: [
    ObjectValuesPipe,
    PropertyCleanPipe,
    CardTableComponent,
    CardTableActionsComponent,
    CardTableRowComponent,
    CardTableActionComponent,
    CardTableHeaderComponent,
    EllipsisComponent,
    GenericTableHeaderComponent,
    MonthPickerComponent,
    YearPickerComponent,
    DateTimePickerComponent,
  ],
  imports: [
    CommonModule,
    NgxPaginationModule,
    MaterialModule,
    FiltersModule,
    MatButtonModule,
    MatNativeDateModule,
    NgxMaterialTimepickerModule,
    NgxSkeletonLoaderModule,
    MatRowComponent,
    MatColComponent,
  ],
  exports: [
    ObjectValuesPipe,
    PropertyCleanPipe,
    CardTableComponent,
    CardTableRowComponent,
    CardTableActionsComponent,
    CardTableActionComponent,
    CardTableHeaderComponent,
    EllipsisComponent,
    GenericTableHeaderComponent,
    MonthPickerComponent,
    YearPickerComponent,
  ],
})
export class CardTableModule {}
